export const roi = {
  menuLabel: 'ROI',
  error: 'Unable to load ROI.',
};
